import $ from 'jquery'
import querystring from 'querystring'

import MapsBase from 'scripts/components/maps/base'
import { showSpinner, hideSpinner } from 'scripts/utils/spinner'
import DEPARTMENTS from 'scripts/constants/departments'

const DEFAULTS = {
  messages: {
    noResults: 'Nenhum produto encontrado, tente outra busca',
    invalidProduct: 'Produto inválido, tente outra busca'
  }
}

class StoreMap extends MapsBase {
  static componentName = 'store-map'

  static DOMEvents = {
    submit: 'onFormSubmit',
    'keyup [data-term]': 'onKeyUp',
    'click [data-toggle-store]': 'onBackToStoresClick'
  }

  constructor (element, options = {}, window = window) {
    super(element, options)
    this.window = window
    this.options.messages = $.extend({}, this.options.messages, DEFAULTS.messages)
  }

  init () {
    this.endpoint = this.$element.attr('action')
    this.token = this.$element.find('[data-token]').val()
    this.$term = this.$element.find('[data-term]')
    this.$button = this.$element.find('[data-submit]')

    this.getMyStore()
    this.showCurrentStore()
  }

  getMyStore () {
    const search = this.window.location.search.slice(1)
    const qs = querystring.parse(search)

    if (qs.region) {
      this.options.region = qs.region
    }

    this.storeId = qs.storeid || this.window.sessionStorage.getItem('storeId')

    if (this.storeId) {
      this.getStoreLabel()
    }
  }

  getStoreLabel () {
    const stores = this.getStoresByRegion()
    const store = stores.find(({ id }) => id === +this.storeId)

    if (store) {
      this.storeId = store.id
      this.storeLabel = store.label
    }
  }

  onFormSubmit (event) {
    event.preventDefault()
    this.$term.blur()

    if (!this.storeId || !this.storeLabel) {
      return this.showModal()
    }

    this.fetchSearch()
  }

  onShowMapClick (event) {
    event.preventDefault()
    const $element = $(event.target)

    this.storeId = $element.data('store-id')
    this.storeLabel = $element.data('store-label')

    this.updateStoreCache()
    this.fetchSearch()
  }

  updateStoreCache () {
    this.window.sessionStorage.setItem('storeId', this.storeId)
    this.showCurrentStore()
  }

  showCurrentStore () {
    if (this.storeLabel) {
      $('[data-store-name]').html(this.storeLabel)
      $('[data-store-legend]').removeClass('hidden')
    }
  }

  fetchSearch () {
    const data = {
      term: this.$term.val(),
      _token: this.token,
      json: true
    }

    if (!data.term) {
      return this.hideModal()
    }

    showSpinner()

    $.get(this.endpoint, data)
      .done(this.onFetchSearchSuccess.bind(this))
      .fail(this.onFetchSearchFailure.bind(this))
  }

  onFetchSearchSuccess (response) {
    const products = response.products || []
    const product = products[0]

    if (!product) {
      return this.showError(this.options.messages.noResults)
    }

    this.fetchProduct(product)
  }

  onFetchSearchFailure () {
    this.showError()
  }

  fetchProduct ({ url }) {
    if (!url) {
      return this.showError(this.options.messages.invalidProduct)
    }

    $.get(url, { json: true })
      .done(this.onFetchProductSuccess.bind(this))
      .fail(this.onFetchProductFailure.bind(this))
  }

  onFetchProductSuccess ({ product }) {
    this.options.department = product.erp_allocation.section
    this.options.section = this.getSectionByDepartment()

    this.fetchStoreMap()
  }

  getSectionByDepartment () {
    return DEPARTMENTS[this.options.department]
  }

  onFetchProductFailure () {
    this.showError()
  }

  onKeyUp () {
    const BTN_ACTIVE = 'red'
    const state = !!this.$term.val()

    this.$button.toggleClass(BTN_ACTIVE, state)
  }
}

export default ($el) => new StoreMap($el, $el.data(), window).init()

export { StoreMap as Component }
